import { render, staticRenderFns } from "./repair-manage.vue?vue&type=template&id=a6920b82&scoped=true"
import script from "./repair-manage.vue?vue&type=script&lang=js"
export * from "./repair-manage.vue?vue&type=script&lang=js"
import style0 from "./repair-manage.vue?vue&type=style&index=0&id=a6920b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6920b82",
  null
  
)

export default component.exports